/* eslint-disable no-console */
import { type Dispatch } from 'redux';
import { onUserLogout } from '@carvana/core-auth';
import * as actions from './actions';
import UserAccountApi from '../../../../shared/apis/UserAccountApi';
import ErrorToast from '../../../../shared/components/Toasts/ErrorToast';
import { ERROR_MESSAGES } from '../constants';
import { KissMetrics } from '../../../../shared/services';

type UpdatePasswordBody = {
  currentPassword: string;
  newPassword: string;
};

export const updatePassword =
  (updatePasswordBody: UpdatePasswordBody, sectionName: string) => (dispatch: Dispatch) => {
    const informationUpdated = ['password'];
    const accountModalWithRedirect =
      '/?openAccountModal=editPasswordSuccess&returnUrl=/account-ui/personal-details';
    dispatch(actions.updatePasswordBegin());
    return UserAccountApi.updatePassword(updatePasswordBody)
      .then(async () => {
        dispatch(actions.updatePasswordSuccess());
        try {
          await onUserLogout();
        } catch {
          // Non-critical: password was already changed successfully
        }
        KissMetrics.trackEvent('Account - Updated Personal Details', {
          SectionName: sectionName,
          InformationUpdated: informationUpdated,
          WasSuccessful: true
        });
        window.location.href = `${process.env.CARVANA_APP_PUBLIC_BASE_URL}${accountModalWithRedirect}`;
      })
      .catch((error) => {
        console.error(error);
        dispatch(actions.updatePasswordFailure(error));
        ErrorToast(ERROR_MESSAGES.UPDATE_PASSWORD, { showFor: 3000 });
        KissMetrics.trackEvent('Account - Updated Personal Details', {
          SectionName: sectionName,
          InformationUpdated: informationUpdated,
          WasSuccessful: false
        });
      });
  };
